var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignmentType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.875 27.0103H20.125C20.9189 27.0103 21.5625 26.4669 21.5625 25.7964V6.3742C21.5625 5.70379 20.9189 5.16032 20.125 5.16032L13.4167 5.2242L2.875 5.16032C2.08109 5.16032 1.4375 5.70379 1.4375 6.3742V25.7964C1.4375 26.4669 2.08109 27.0103 2.875 27.0103ZM20.125 28.2242H2.875C1.28718 28.2242 0 27.1372 0 25.7964V6.3742C0 5.03338 1.28718 3.94643 2.875 3.94643H13.4635L13.4167 5.2242L20.125 5.16032V3.94643C21.7128 3.94643 23 5.03338 23 6.3742V25.7964C23 27.1372 21.7128 28.2242 20.125 28.2242Z",
    fill: "#001B4A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.83203,
    y: 15.4464,
    width: 15.3333,
    height: 1.27778,
    rx: 0.638889,
    fill: "#001B4A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.83203,
    y: 12.8917,
    width: 10.2222,
    height: 1.27778,
    rx: 0.638889,
    fill: "#001B4A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.83203,
    y: 10.3361,
    width: 6.38889,
    height: 1.27778,
    rx: 0.638889,
    fill: "#001B4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.83203,
    y: 18.6417,
    width: 15.3333,
    height: 1.27778,
    rx: 0.638889,
    fill: "#001B4A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.83203,
    y: 21.8361,
    width: 15.3333,
    height: 1.27778,
    rx: 0.638889,
    fill: "#001B4A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_223_1542",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 14,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2778 0.114464H11.5V12.8922H24.2778V0.114464Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_223_1542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0508 7.7807V4.58625C14.0508 2.82201 15.481 1.39181 17.2452 1.39181C19.0095 1.39181 20.4397 2.82201 20.4397 4.58625V8.84551C20.4397 10.0217 19.4862 10.9751 18.31 10.9751C17.1339 10.9751 16.1804 10.0217 16.1804 8.84551V4.58625C16.1804 3.99817 16.6571 3.52144 17.2452 3.52144C17.8333 3.52144 18.31 3.99817 18.31 4.58625V8.84551",
    stroke: "#001B4A",
    strokeWidth: 1.33102,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentType);
export default __webpack_public_path__ + "static/media/assignment-type.0e2463e901d857ea18790651cba1ef1c.svg";
export { ForwardRef as ReactComponent };